import { useSearchParams } from 'react-router';
import { CorporateViewTabs } from 'components/MapPage/CorporateViewTabGroup';

/** True when Hub SitStat is the active openTab (map dual-surface SitStat mode). */
export function useIsSitStatMode(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.get('openTab') === CorporateViewTabs.SitStat;
}
